import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradebookSyncSetup from "./routes/GradebookSyncSetup";
export default store => ({
  path: "gradebook-sync",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/GradebookSyncModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "Integrations/modules/IntegrationsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;

        const integrationsModuleKey = importedModule2.NAME;
        const integrationsModuleReducer = importedModule2.default;

        injectReducer(store, {
          key: "gradebookSync",
          reducer,
        });

        injectReducer(store, {
          key: integrationsModuleKey,
          reducer: integrationsModuleReducer,
        });

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [GradebookSyncSetup(store)],
});
